import { useCallback, useEffect, useRef, useState } from 'react';

const IDLE = { status: 'idle', result: null };

// Runs one bridge call at a time with an AbortController, so unmounting the
// screen or pressing "Cancelar" really cancels (and dismisses native UI).
export function useBridgeAction() {
    const [state, setState] = useState(IDLE);
    const controllerRef = useRef(null);

    useEffect(() => () => controllerRef.current?.abort(), []);

    const run = useCallback(async (call) => {
        controllerRef.current?.abort();
        const controller = new AbortController();
        controllerRef.current = controller;
        setState({ status: 'pending', result: null });
        const result = await call(controller.signal);
        if (controllerRef.current !== controller) return result;
        controllerRef.current = null;
        setState({ status: result.ok ? 'success' : 'error', result });
        return result;
    }, []);

    const cancel = useCallback(() => {
        controllerRef.current?.abort();
    }, []);

    return { ...state, isPending: state.status === 'pending', run, cancel };
}
